<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card">
      <div class="searchaccounts">
        <div class="searchcardheader">
          <p>حساب ها</p>
          <img
            class="nofilter"
            src="@/assets/icons/noFilter.svg"
            @click="userDeleteoFilter"
          />
        </div>
        <input
          v-model="destination"
          placeholder="حساب، شماره تلفن، ایمیل"
          @keyup.enter="searchUser"
          @keyup="searchUser"
        />
        <div v-if="findUser" class="filterresults">
          {{ destinationUser.keyword }}
          <img :src="avatar" />
        </div>
      </div>
      <div class="searchaccounts">
        <div class="searchcardheader">
          <p>بازه زمانی</p>
          <img class="nofilter" src="@/assets/icons/noFilter.svg" />
        </div>
        <div class="datadArea">
          <div class="dateD">امروز</div>
          <div class="dateD">این هفته</div>
          <div class="dateD">این ماه</div>
          <div class="dateD">امسال</div>
        </div>
      </div>

      <div class="searchaccounts">
        <div class="searchcardheader">
          <p>میزان</p>
          <img class="nofilter" src="@/assets/icons/noFilter.svg" />
        </div>
        <div class="slid-dd">
          <vue-slider
            v-model="value"
            :min="0"
            :max="100000000000000"
          ></vue-slider>
        </div>
        <div class="val">
          {{ formatPrice(value[0]) }}
        </div>
        <div class="val">
          {{ formatPrice(value[1]) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InsHeader from "../../../layouts/inside-header.vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
export default {
  components: {
    InsHeader,
    VueSlider,
  },
  mounted() {},
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {
      value: [0, 100000000000000],
      findUser: false,
      destinationUser: {
        keyword: null,
        destination_id: null,
      },
      avatar: null,
      filterDate: {
        from_date: "null",
        to_date: "null",
      },
      user_account_ids: ["null"],
      account_ids: ["null"],
      type: "all",
      amount: { from_amount: null, to_amount: null },
    };
  },
  methods: {
    searchUser() {
      setTimeout(() => {
        var data = {
          keyword: this.destination,
        };
        this.$store.dispatch("transaction/findUser", data).then((rsp) => {
          this.destinationUser = rsp;
          this.findUser = true;
          this.avatar = "https://media-dev.bfst.ir/" + rsp.avatar;
        });
      }, 1500);
    },
    userDeleteoFilter() {
      this.findUser = false;
      this.destination = null;
      this.destinationUser = {};
    },
    formatPrice(vale) {
      let val = (vale / 1).toFixed(0).replace(".", ",");
      return val.toLocaleString("fa-IR").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    chenge() {
      this.filterData.amount.from_amount = this.value[0];
      this.filterData.amount.to_amount = this.value[1];
      this.filterData.amount.account_ids[0] =
        this.destinationUser.destination_id;
      setTimeout(() => {
        var data = {
          data: this.filterDate,
        };
        this.$store.dispatch("transaction/filter", data).then((rsp) => {
          this.$store.commit("transaction/distinationTransaction", rsp);
        });
      }, 5000);
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.val {
  background: #fff;
  border-radius: 40px;
  width: fit-content;
  display: unset;
  margin-right: 12px;
  margin-bottom: 12px;
  padding: 11px;
}
.slid-dd {
  margin-top: 41px;
  margin-bottom: 20px;
}
.dateD {
  font-family: "vazir";
  background: #fff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 10px;
  padding: 5px;
  font-size: 12px;
  display: inline;
  margin: 6px;
}
.datadArea {
  margin-top: 40px;
  margin-bottom: 10px;
}
</style>
